import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginUser } from "../../services/authService";
import { useAuth } from "../../context/AuthContext";
import "../../css/admin.css"; // or reuse login css directly

const AdminLogin = () => {
    const navigate = useNavigate();

    const { setAccessToken, setRole, setDisplayName } = useAuth();
    const [errors, setErrors] = useState({});
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setLoading(true);

        // Clear any stale auth
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        localStorage.removeItem("role");

        try {
            const response = await loginUser({
                username,       // or username if your backend uses username
                password,
            });

            const {
                access,
                role: userRole,
                first_name,
                expires_at,
            } = response.data;

            if (userRole !== "admin") {
                throw new Error("Unauthorized");
            }

            // Store exactly like normal login
            localStorage.setItem("access", access);
            localStorage.setItem("role", userRole);
            localStorage.setItem("first_name", first_name);
            localStorage.setItem("expires_at", expires_at * 1000);

            setAccessToken(access);
            setRole(userRole);
            setDisplayName(first_name);

            toast.success("Welcome back, Admin");
            navigate("/admin");

        } catch (err) {
            toast.error("Invalid admin credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="full-login">
            <div className="login-home-container">
                <form className="login-form" onSubmit={handleSubmit}>
                    <h2>Admin Access</h2>

                    <div className="login-form-group">
                        <label>Username</label>
                        <input
                            type="text"
                            placeholder="Admin username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>

                    <div className="login-form-group ">
                        <label>Password</label>
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="login-button"
                        disabled={loading}
                    >
                        {loading ? "Signing in..." : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;